import { mergeSxObject } from '../../helpers'
import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<
    'primary' | 'secondary' | 'tertiary' | 'error' | 'warning' | 'success' | 'informative' | 'goGreen' | 'inherit'
  >

  /**
   * When you want to inherit the font from parent, or instead of using <strong> inside your font :)
   */
  weight?: 'inherit' | 'bold'
}>

export const Body1 = ({ children, variant = 'primary', sx, weight, ...rest }: Props) => (
  <BaseTypography variant="body1" color={variant} sx={mergeSxObject(sx, { fontWeight: weight })} {...rest}>
    {children}
  </BaseTypography>
)
